import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

axios.defaults.withCredentials = true;

let refreshing = null;
axios.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config;
  if (error.response?.status !== 401 || !cfg || cfg._retried || cfg.url.includes("/auth/")) throw error;
  cfg._retried = true;
  refreshing = refreshing || axios.post(`${API}/auth/refresh`).finally(() => (refreshing = null));
  await refreshing.catch(() => {
    throw error;
  });
  return axios(cfg);
});

export const api = {
  listProjects: () => axios.get(`${API}/projects`).then((r) => r.data),
  getProject: (id) => axios.get(`${API}/projects/${id}`).then((r) => r.data),
  createProject: (body) => axios.post(`${API}/projects`, body).then((r) => r.data),
  updateProject: (id, body) => axios.put(`${API}/projects/${id}`, body).then((r) => r.data),
  deleteProject: (id) => axios.delete(`${API}/projects/${id}`).then((r) => r.data),
  uploadAudio: (blob, filename) => {
    const fd = new FormData();
    fd.append("file", blob, filename);
    return axios.post(`${API}/audio`, fd).then((r) => r.data);
  },
  fetchAudio: (fileId) =>
    axios.get(`${API}/audio/${fileId}`, { responseType: "arraybuffer" }).then((r) => r.data),
  listDemos: () => axios.get(`${API}/projects-demos`).then((r) => r.data),
  duplicateProject: (id, body) => axios.post(`${API}/projects/${id}/duplicate`, body).then((r) => r.data),
  me: () => axios.get(`${API}/auth/me`).then((r) => r.data),
  login: (body) => axios.post(`${API}/auth/login`, body).then((r) => r.data),
  register: (body) => axios.post(`${API}/auth/register`, body).then((r) => r.data),
  googleSession: (session_id) => axios.post(`${API}/auth/google/session`, { session_id }).then((r) => r.data),
  logout: () => axios.post(`${API}/auth/logout`).then((r) => r.data),
  billingStatus: () => axios.get(`${API}/billing/status`).then((r) => r.data),
  subscribe: (origin, interval) => axios.post(`${API}/billing/subscribe`, { origin, interval }).then((r) => r.data),
  stripeCheckout: (origin, interval, promo_code) => axios.post(`${API}/billing/stripe/checkout`, { origin, interval, promo_code }).then((r) => r.data),
  redeemCode: (code, origin) => axios.post(`${API}/codes/redeem`, { code, origin }).then((r) => r.data),
  adminCodes: () => axios.get(`${API}/admin/codes`).then((r) => r.data),
  createCode: (body) => axios.post(`${API}/admin/codes`, body).then((r) => r.data),
  setCodeActive: (code, active) => axios.patch(`${API}/admin/codes/${code}`, { active }).then((r) => r.data),
  paymentStatus: (sessionId) => axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data),
  stripePortal: (origin) => axios.post(`${API}/billing/stripe/portal`, { origin }).then((r) => r.data),
  stripeSync: () => axios.post(`${API}/billing/stripe/sync`).then((r) => r.data),
  createShare: (body) => axios.post(`${API}/shares`, body).then((r) => r.data),
  listShares: (projectId) => axios.get(`${API}/shares`, { params: { project_id: projectId } }).then((r) => r.data),
  getShare: (id) => axios.get(`${API}/shares/${id}`).then((r) => r.data),
  deleteShare: (id) => axios.delete(`${API}/shares/${id}`).then((r) => r.data),
  confirmSubscription: (subscription_id) => axios.post(`${API}/billing/confirm`, { subscription_id }).then((r) => r.data),
  cancelSubscription: () => axios.post(`${API}/billing/cancel`).then((r) => r.data),
  suggestHarmony: (body) => axios.post(`${API}/harmony/suggest`, body).then((r) => r.data),
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
};
